import { Component, OnInit, Input, Output, EventEmitter, AfterViewChecked, ViewChild, ElementRef } from "@angular/core";
import { MedicalOrderScann } from "../../../model/medical-order-scann";
import { NotificationToastService } from "../../../services/notification-toast.service";
import {
  DomSanitizer,
  SafeUrl,
  SafeResourceUrl,
} from "@angular/platform-browser";
import { MatDialog } from "@angular/material";
import { MedicalOrderScannDialogComponent } from "../../dialogs/medical-order-scann/medical-order-scann-dialog.component";
import { FormGroup, FormBuilder } from "@angular/forms";
import { MedicalOrderService } from "../../../services/medical-order.service";
import { MedicalOrderScannType } from "../../../model/medical-order-scann-type";
import { FilterService } from "../../../services/filter.service";
import { MedicalOrderScannZoomDialogComponent } from "../../dialogs/medical-order-scann-zoom/medical-order-scann-zoom-dialog.component";
import { Scanner } from "../../../model/scanner/scanner";
import { AuthService } from "../../../services/auth.service";
import { ScannerDialogComponent } from "../../dialogs/scanner/scanner-dialog.component";
import { ImagePrintService } from "../../../services/image-print.service";
import { MedicalOrderScannInfo } from "../../../model/medical-order-scann-info";
import { PdfService } from "src/app/services/pdf.service";
import { MedicalOrderProcedureExtractionComponent } from "../../dialogs/medical-order-procedure-extraction/medical-order-procedure-extraction.component";
import { MedicalOrderProcedureExtraction } from "src/app/model/medical-order-procedure-extraction/medical-order-procedure-extraction";

@Component({
  // tslint:disable-next-line:component-selector
  selector: "medical-order-scann-control",
  templateUrl: "medical-order-scann-control.component.html",
  styleUrls: ["./medical-order-scann-control.component.css"],
})
export class MedicalOrderScannControlComponent implements OnInit, AfterViewChecked {
  hideElement = true;
  uploading = false;
  dragOver = false;
  dragCounter = 0;
  scanner: Scanner;
  deleting: boolean;
  loading: boolean;
  loadingImage: boolean;
  medicalOrderScannTypes: MedicalOrderScannType[];

  medicalOrderScannInfo: MedicalOrderScannInfo;
  index: number;
  public form: FormGroup;

  @Output() onMecicalOrderScannChange = new EventEmitter<MedicalOrderScann[]>();
  @Output() onMecicalOrderSelected = new EventEmitter<
    string
  >();

  @Input() medicalsOrderScann: MedicalOrderScann[];

  @Input() hideScanner: boolean = false;
  @Input() readOnly: boolean = false;
  @Input() canSelect: boolean = false;
  @Input() medicalorderId?: number;
  @Input() canScann: boolean = true;
  @Input() hideProcedures = false;
  @Input() deliveryDate: string | null = null;
  @Input() showPracticeCounts = false;
  @ViewChild("practicesText", { static: false }) practicesText: ElementRef<HTMLElement>;
  private practiceCountsShown = false;

  safeUrl: SafeResourceUrl | null;

  get isMedicalOrderScannTypeSelected(): boolean {
    return (
      this.form.value.medicalOrderScannType &&
      this.form.value.medicalOrderScannType.IsOrder &&
      this.medicalsOrderScann.length > 0 &&
      this.index > -1
    );
  }

  constructor(
    private notificationToastService: NotificationToastService,
    private medicalOrderService: MedicalOrderService,
    private imagePrintService: ImagePrintService,
    private filterService: FilterService,
    public dialog: MatDialog,
    private authService: AuthService,
    private pdfService: PdfService,
    private formBuilder: FormBuilder,
    private domSanitizer: DomSanitizer
  ) {
    this.medicalsOrderScann = [];
    this.index = -1;
    this.form = this.formBuilder.group({
      medicalOrderScannType: [null],
    });
  }

  mecicalOrderSelected(): void {
    if (this.medicalsOrderScann.length > 0 && this.index > -1) {
      const base64 = this.getBase64(this.medicalOrderScann, !this.isImg());
      this.onMecicalOrderSelected.emit(base64);
    }
  }

  async ngOnInit() {
    try {
      this.loading = true;
      this.authService.getUserScanner().then((scanner) => {
        this.scanner = scanner;
      });

      this.medicalOrderScannTypes =
        await this.filterService.getMedicalOrderScannTypesFilter();
      this.form.patchValue({
        medicalOrderScannType: this.medicalOrderScannTypes[0],
      });

      if (this.medicalorderId) {
        this.medicalsOrderScann =
          await this.medicalOrderService.getMedicalsOrderScann(
            this.medicalorderId
          );
        this.medicalOrderScannInfo =
          await this.medicalOrderService.getMedicalOrderScannInfo(
            this.medicalorderId
          );
      }

      if (this.filteredMedicalOrderScann.length > 0) {
        this.index = 0;
        this.setSafeUrl();
      }

      this.onMecicalOrderScannChange.emit(this.medicalsOrderScann);
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Orden escaneos"
      );
    } finally {
      this.loading = false;
    }
  }

  ngAfterViewChecked(): void {
    if (!this.showPracticeCounts || this.practiceCountsShown ||
        !this.medicalOrderScannInfo || !this.practicesText) {
      return;
    }

    const received = this.medicalOrderScannInfo.Practices;
    const displayed = this.practicesText.nativeElement.textContent.trim();
    const count = (text: string) => text.split(",").filter(name => name.trim().length > 0).length;
    this.practiceCountsShown = true;

    alert(
      "Practicas recibidas: " + count(received) +
      "\nPracticas renderizadas: " + count(displayed) +
      "\nConteo estimado por nombres separados por comas." +
      "\nTexto completo renderizado: " + (received.trim() === displayed ? "Si" : "No") +
      "\nNo verifica recortes visuales por CSS."
    );
  }

  async rotate() {
    if (this.medicalsOrderScann.length > 0) {
      this.loadingImage = true;
      try {
        const medicalOrderScann = this.medicalOrderScann;
        medicalOrderScann.Image64 =
          await this.medicalOrderService.medicalOrderScannRotate(
            medicalOrderScann
          );
        this.setSafeUrl();
      } catch (err) {
        this.notificationToastService.error(
          JSON.stringify(err.error),
          "Orden escaneos"
        );
      } finally {
        this.loadingImage = false;
      }
    }
  }

  async remove() {
    try {
      this.deleting = true;
      if (this.medicalsOrderScann.length > 0) {
        const inx = this.medicalsOrderScann.findIndex(
          (ms) => ms === this.medicalOrderScann
        );
        await this.medicalOrderService.medicalOrderScannDelete(
          this.medicalsOrderScann[inx]
        );
        this.medicalsOrderScann.splice(inx, 1);
        if (this.index > this.filteredMedicalOrderScann.length - 1) {
          this.index = this.filteredMedicalOrderScann.length - 1;
        }

        this.onMecicalOrderScannChange.emit(this.medicalsOrderScann);

        this.setSafeUrl();
      }
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Orden escaneos"
      );
    } finally {
      this.deleting = false;
    }
  }

  get medicalOrderScann(): MedicalOrderScann {
    if (this.filteredMedicalOrderScann.length > 0) {
      return this.filteredMedicalOrderScann[this.index];
    } else {
      return null;
    }
  }

  get filteredMedicalOrderScann(): MedicalOrderScann[] {
    let filtered: MedicalOrderScann[] = [];

    if (
      this.form.value.medicalOrderScannType &&
      this.medicalsOrderScann.length > 0
    ) {
      filtered = this.medicalsOrderScann.filter(
        (ms) =>
          ms.MedicalOrderScannTypeId ===
          (<MedicalOrderScannType>this.form.value.medicalOrderScannType).Id
      );
    }

    return filtered;
  }

  medicalOrderScannTypeChange(): void {
    this.index = 0;
    this.setSafeUrl();
  }

  getDisplayIndex(): string {
    const total = this.filteredMedicalOrderScann.length;
    const actual = this.index + 1;
    return actual + " de " + total;
  }

  getSafeUrlIfNeed(medicalOrdenScann: MedicalOrderScann): SafeUrl {
    if (
      medicalOrdenScann.ImageName &&
      medicalOrdenScann.ImageName.includes("base64")
    ) {
      return this.domSanitizer.bypassSecurityTrustUrl(
        medicalOrdenScann.Image64
      );
    } else {
      return this.domSanitizer.bypassSecurityTrustUrl(
        "data:image/jpg;base64," + medicalOrdenScann.Image64
      );
    }
  }

  getSafePdfUrlIfNeed(medicalOrdenScann: MedicalOrderScann): SafeUrl {
    if (
      medicalOrdenScann.ImageName &&
      medicalOrdenScann.ImageName.includes("base64")
    ) {
      return this.domSanitizer.bypassSecurityTrustUrl(
        medicalOrdenScann.Image64
      );
    } else {
      return this.domSanitizer.bypassSecurityTrustUrl(
        "data:application/pdf;base64," + medicalOrdenScann.Image64
      );
    }
  }

  getBase64(
    medicalOrdenScann: MedicalOrderScann,
    isPdf: boolean = false
  ): string {
    if (
      medicalOrdenScann.ImageName &&
      medicalOrdenScann.ImageName.includes("base64")
    ) {
      return medicalOrdenScann.Image64;
    } else {
      const prefix = isPdf
        ? "data:application/pdf;base64,"
        : "data:image/jpeg;base64,";

      return prefix + medicalOrdenScann.Image64;
    }
  }

  existsMedicalsOrderScann(): boolean {
    return this.filteredMedicalOrderScann.length > 0;
  }

  goBack(): void {
    if (this.index > 0) {
      this.index = this.index - 1;
      this.setSafeUrl();
    }
  }

  next(): void {
    if (this.filteredMedicalOrderScann.length - 1 > this.index) {
      this.index = this.index + 1;
      this.setSafeUrl();
    }
  }

  zoom(): void {
    const dialogRef = this.dialog.open(MedicalOrderScannZoomDialogComponent, {
      width: "95%",
      height: "95%",
      data: {
        url: this.getBase64(this.medicalOrderScann),
        base64: this.medicalOrderScann.Image64,
      },
    });
  }

  safeResourceUrl: SafeResourceUrl | null;

  getSafeResourceUrl() {
    return this.safeResourceUrl;
  }

  getSafeUrl() {
    return this.safeUrl;
  }

  setSafeUrl(): void {
    this.safeUrl = null;
    this.safeResourceUrl = null;
    if (this.medicalOrderScann) {
      this.loadingImage = true;

      if (!this.medicalOrderScann.Image64) {
        this.medicalOrderService
          .getMedicalOrderScann(this.medicalOrderScann.Id)
          .then((complete) => {
            this.medicalOrderScann.Image64 = complete.Image64;
            if (this.isImg()) {
              this.safeUrl = this.getSafeUrlIfNeed(this.medicalOrderScann);
            } else {
              this.safeResourceUrl = this.pdfService.base64ToPdfSafeResourceUrl(
                this.medicalOrderScann.Image64
              );
            }
            this.loadingImage = false;
          });
      } else {
        if (this.isImg()) {
          this.safeUrl = this.getSafeUrlIfNeed(this.medicalOrderScann);
        } else {
          this.safeResourceUrl = this.pdfService.base64ToPdfSafeResourceUrl(
            this.medicalOrderScann.Image64
          );
        }
        this.loadingImage = false;
      }
    } else {
      this.loadingImage = false;
    }
  }

  isImg(): boolean {
    if (this.medicalOrderScann) {
      return this.medicalOrderScann.ImageName
        ? !this.medicalOrderScann.ImageName.endsWith(".pdf")
        : true;
    } else {
      return false;
    }
  }

  openScannSet(): void {
    const dialogRef = this.dialog.open(ScannerDialogComponent, {
      width: "50%",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.authService.getUserScanner().then((scanner) => {
          this.scanner = scanner;
        });
      }
    });
  }

  onDragEnter(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.dragCounter += 1;
    this.dragOver = true;
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.dragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.dragCounter = Math.max(0, this.dragCounter - 1);
    this.dragOver = this.dragCounter > 0;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.dragCounter = 0;
    this.dragOver = false;

    if (event.dataTransfer && event.dataTransfer.files.length > 0) {
      this.uploadFile(event.dataTransfer.files);
    }
  }

  private isValidUploadFile(file: File): boolean {
    const fileName = file.name.toLowerCase();
    return file.type.startsWith("image/") || fileName.endsWith(".pdf");
  }

  uploadFile(event: FileList | File[]) {
    const files = Array.isArray(event) ? event : Array.prototype.slice.call(event);

    for (let index = 0; index < files.length; index++) {
      const element = files[index];

      if (!this.isValidUploadFile(element)) {
        this.notificationToastService.error(
          "Solo se permiten imágenes o archivos PDF.",
          "Orden escaneos"
        );
        continue;
      }

      const reader = new FileReader();
      reader.readAsDataURL(element);
      this.uploading = true;

      reader.onload = (_event) => {
        const medicalOrderScanns: MedicalOrderScann[] = [];
        const medicalOrderScann = new MedicalOrderScann();
        const base64Url = <string>reader.result;

        medicalOrderScann.Image64 = base64Url.split("base64,")[1];
        medicalOrderScann.ImageName = element.name;
        medicalOrderScann.MedicalOrderId = this.medicalorderId;

        medicalOrderScann.MedicalOrderScannTypeId = (<MedicalOrderScannType>(
          this.form.value.medicalOrderScannType
        )).Id;

        this.safeResourceUrl = null;
        medicalOrderScanns.push(medicalOrderScann);

        if (!this.medicalorderId) {
          this.medicalsOrderScann.push(medicalOrderScanns[0]);
          this.index = this.filteredMedicalOrderScann.length - 1;
          this.setSafeUrl();
          this.uploading = false;
          this.onMecicalOrderScannChange.emit(this.medicalsOrderScann);
        } else {
          this.medicalOrderService
            .medicalOrderScannUpdate(medicalOrderScanns)
            .then((itemUpdated) => {
              medicalOrderScanns[0].Id = itemUpdated[0].MedicalOrderScannId;
              this.medicalsOrderScann.push(medicalOrderScanns[0]);
              this.index = this.filteredMedicalOrderScann.length - 1;
              this.setSafeUrl();
              this.uploading = false;
              this.onMecicalOrderScannChange.emit(this.medicalsOrderScann);
            })
            .catch((err) => {
              this.notificationToastService.error(
                JSON.stringify(err.error),
                "Orden escaneos"
              );
              this.uploading = false;
            });
        }
      };
    }
  }

  openMedicalOrderScannDialog(): void {
    if (this.form.value.medicalOrderScannType && this.medicalorderId) {
      const dialogRef = this.dialog.open(MedicalOrderScannDialogComponent, {
        width: "90%",
        data: {
          MedicalOrderId: this.medicalorderId,
          MedicalOrderScannType: <MedicalOrderScannType>(
            this.form.value.medicalOrderScannType
          ),
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          const resultMedicalOrderScann = <MedicalOrderScann[]>result;
          if (resultMedicalOrderScann.length > 0) {
            resultMedicalOrderScann.forEach((item) => {
              this.medicalsOrderScann.push(item);
            });
          }

          this.index = this.filteredMedicalOrderScann.length - 1;
          this.setSafeUrl();
        }
      });
    }
  }

  async print() {
    try {
      if (this.medicalsOrderScann.length > 0 && this.index > -1) {
        const base64 = this.medicalOrderScann.Image64;
        if (this.isImg()) {
          this.imagePrintService.base64ToImagePrint(base64, "", true);
        } else {
          this.pdfService.base64ToPdfPrint(base64);
        }
      }
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Orden escaneos"
      );
    } finally {
      this.deleting = false;
    }
  }
}
